import { IBaseResponse } from 'shared/typings';

export enum ESourceTypes {
	WEBSITE = 'website',
	BLOGGER = 'influencer',
	ARBITRATION = 'arbitrage',
}

export enum EVerificationTypes {
	BY_CODE = 'by_code',
	BY_EMAIL = 'by_email',
}

export enum ESourceStatuses {
	NEW = 'new',
	ON_VERIFICATION = 'on_verification',
	ON_MODERATION = 'on_moderation',
	ACTIVE = 'active',
	REJECTED = 'rejected',
}

export enum EVerificationOpenForm {
	VERIFY = 'verify',
	CREATE = 'create',
	ONBOARDING = 'onboarding',
}

export enum EPurchaseTypes {
	SOCIAL_MEDIA_ADS = 'social_media_ads',
	SEARCH_ENGINE_ADS = 'search_engine_ads',
	OTHERS = 'others',
}
export enum EPlatformTypes {
	DZEN = 'dzen',
	LIKEE = 'likee_video',
	RUTUBE = 'rutube',
	TELEGRAM = 'telegram',
	YOUTUBE = 'youtube',
	OK = 'ok',
	PINTEREST = 'pintererest',
	SNAPCHAT = 'snapchat',
	TIKTOK = 'tiktok',
	TWICH = 'twich',
	VK = 'vk',
	VK_VIDEO = 'vk_video',
	WECHAT = 'wechat',
	WHATSAPP = 'whatsapp',
	VC = 'vc',
}

export interface IWebsiteSource {
	url: string;
	platform_type: string;
	countries: string[];
	content_themes: string[];
	extension_exists: boolean;
	extension_description: string;
}

export interface IWebsiteForm {
	name: string;
	url: string;
	platform_type: string | null;
	countries: string[];
	content_themes: string[];
	extension_exists: boolean;
	extension_description: string;
}

export interface IBloggerUrl {
	code?: string;
	platform_type: string;
	url: string;
}

export interface IBloggerSource {
	platform_types: string[];
	countries: string[];
	content_themes: string[];
	urls: IBloggerUrl[];
}

export interface IBloggerForm {
	name: string;
	platform_types: string[];
	countries: string[];
	content_themes: string[];
}

export interface IArbitrageUrl {
	code?: string;
	url: string;
}

export interface IArbitrageSource {
	purchase_type: EPurchaseTypes | null;
	urls: IArbitrageUrl[];
	countries: string[];
	description: string;
	screenshots: string[];
}

export interface IArbitrageForm {
	name: string;
	purchase_type: EPurchaseTypes | null;
	url1: string;
	url2: string;
	url3: string;
	url4: string;
	url5: string;
	urls: ('1' | '2' | '3' | '4' | '5')[];
	countries: string[];
	description: string;
	screenshots: string[];
}

export interface ISource {
	uuid: string;
	name: string;
	url: string;
	type: ESourceTypes;
	website_data: IWebsiteSource;
	influencer_data: IBloggerSource;
	arbitrage_data: IArbitrageSource;
	status: ESourceStatuses;
	rejection_comment: string;
	joined_offers_count: number;
}

export type TSourceList = IBaseResponse<ISource[] | null>;
export type TUpdateSourceRequest = Omit<ISource, 'status'>;
export type TCreateSourceRequest = Omit<ISource, 'status' | 'uuid' | 'rejection_comment' | 'joined_offers_count'>;

export interface ICreateVerification {
	source_pk: string;
}
